module.exports = __webpack_public_path__ + "img/social-media-img.c74ef0fd.jpg";